export default __webpack_public_path__ + "static/media/farming-simulator@2x.419c959b.webp";